import axiosInstance from '../utils/AxiosConfig';

export const downloadBulkImportTemplate = async (type) => {
  const response = await axiosInstance.get(`/bulk_import/${type}/template`, {
    responseType: 'blob',
  });

  const contentDisposition = response.headers?.['content-disposition'] || '';
  const match = contentDisposition.match(/filename="?([^"]+)"?/i);
  const filename = match?.[1] || `${type}_template.xlsx`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const uploadBulkImportFile = async (type, file, action) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosInstance.post(`/bulk_import/${type}/${action}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

export const validateBulkImport = (type, file) => uploadBulkImportFile(type, file, 'validate');

export const commitBulkImport = (type, file) => uploadBulkImportFile(type, file, 'commit');
